import { defineComponent as _defineComponent } from 'vue'
import useTranslations from "@/composables/useTranslations";


export default /*#__PURE__*/_defineComponent({
  __name: 'ElErrorLandingPage',
  setup(__props) {

const { $t } = useTranslations();

return { __sfc: true,$t }
}

})